/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Locked_ConfirmInputs */

const en_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue in Read-Only Mode`)
};

const fr_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer en mode lecture seule`)
};

const de_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Nur-Lese-Modus fortfahren`)
};

const it_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua in modalità di sola lettura`)
};

const ru_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить в режиме только для чтения`)
};

const es_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar en modo de solo lectura`)
};

const zh_cn2_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续以只读模式`)
};

const ja_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り専用モードで続行`)
};

const hi_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल पढ़ने के मोड में जारी रखें`)
};

const pt_pt2_explorer_thumbnail_locked_confirm = /** @type {(inputs: Explorer_Thumbnail_Locked_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar no modo somente leitura`)
};

/**
* | output |
* | --- |
* | "Continue in Read-Only Mode" |
*
* @param {Explorer_Thumbnail_Locked_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_locked_confirm = /** @type {((inputs?: Explorer_Thumbnail_Locked_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Locked_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "de") return de_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "it") return it_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "es") return es_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_locked_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_locked_confirm(inputs)
	return en_explorer_thumbnail_locked_confirm(inputs)
});